import boletaApi from "./boletaApi";

/**
 * Builds a user-visible message from an axios/API error.
 * @param {Error & { response?: { data?: unknown } }} error
 * @returns {string}
 */
export function getImportEmployeesErrorMessage(error) {
  const data = error.response?.data;
  if (typeof data === "string" && data.trim()) return data.trim();
  if (data && typeof data.message === "string" && data.message.trim()) {
    let base = data.message.trim();
    if (Array.isArray(data.failedRows) && data.failedRows.length > 0) {
      const lines = data.failedRows
        .slice(0, 12)
        .map(
          (r) =>
            `Fila ${r.rowIndex1Based} — DNI ${r.dni ?? "?"} — CUIL ${r.cuil ?? "?"}: ${r.reason || "Error"}`
        );
      const more =
        data.failedRows.length > 12 ? `\n…y ${data.failedRows.length - 12} fila(s) más.` : "";
      base = `${base}\n${lines.join("\n")}${more}`;
    }
    return base;
  }
  if (error.message === "Network Error") {
    return "No se pudo conectar con el servidor. Comprobá tu conexión e intentá de nuevo.";
  }
  if (error.message && error.message.trim()) {
    return error.message.trim();
  }
  if (!error.response) {
    return "No se pudo conectar con el servidor. Comprobá tu conexión e intentá de nuevo.";
  }
  return "Error al importar empleados";
}

/**
 * Maps raw server messages (e.g. Mongo duplicate key) to clearer copy for the UI.
 * @param {string} raw
 * @returns {string}
 */
export function friendlyImportEmployeesError(raw) {
  if (!raw || typeof raw !== "string") return "Error al importar empleados";
  const lower = raw.toLowerCase();
  if (
    lower.includes("11000") ||
    lower.includes("e11000") ||
    lower.includes("duplicate key") ||
    (lower.includes("dni") && lower.includes("dup key"))
  ) {
    return "No se pudo completar la importación: el DNI ya existe en el sistema (puede coincidir con otro CUIL en la base). Revisá la planilla o el registro existente.";
  }
  return raw;
}

export const employeesImporter = async (employees) => {
  const res = await boletaApi.post("/importEmployees", employees);
  return res;
};
